import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/pricing/PricingPageClient.tsx");
